/* Xtreme own reviews: star picker, photo resize, JSON submit, photo lightbox. No innerHTML anywhere. */
(function () {
  'use strict';

  var MAX_PHOTOS = 3;
  // The review link in the follow-up email carries ?xtrt=<token>, which proves the purchase.
  var purchaseToken = '';
  try { purchaseToken = new URLSearchParams(window.location.search).get('xtrt') || ''; } catch (e) { purchaseToken = ''; }
  var MAX_EDGE = 1200;

  function readAsImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('Could not read ' + file.name)); };
      img.src = url;
    });
  }

  // Resize to max 1200px and re-encode as JPEG so uploads stay small (and metadata is dropped).
  function resizePhoto(file) {
    return readAsImage(file).then(function (img) {
      var scale = Math.min(1, MAX_EDGE / Math.max(img.naturalWidth, img.naturalHeight));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg', 0.8);
    });
  }

  function initForm(root) {
    var form = root.querySelector('.xt-rv-form');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var openBtn = root.querySelector('.xt-rv-open');
    var thanks = root.querySelector('.xt-rv-thanks');
    var errorEl = form.querySelector('.xt-rv-error');
    var submit = form.querySelector('.xt-rv-submit');
    var picks = form.querySelectorAll('.xt-rv-pick');
    var rating = 0;

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    function setRating(value) {
      rating = value;
      picks.forEach(function (b) {
        var v = Number(b.dataset.value);
        b.setAttribute('aria-checked', String(v === value));
        b.classList.toggle('is-on', v <= value);
      });
    }

    picks.forEach(function (b) {
      b.addEventListener('click', function () { setRating(Number(b.dataset.value)); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); setRating(Math.min(5, rating + 1)); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); setRating(Math.max(1, rating - 1)); }
      });
    });

    if (purchaseToken) {
      var attempts = 0;
      // The theme's own tab script may bind after ours, so keep trying until the reviews are actually visible.
      // The theme hides inactive tabs with visibility/opacity, not display:none, so offsetParent alone calls a hidden tab "shown".
      var shown = function () { return root.offsetParent !== null && window.getComputedStyle(root).visibility !== 'hidden'; };
      var reveal = function () {
        var tab = document.querySelector('.js-tab-control[data-target="#product_description_tab_review"]');
        if (tab && !shown()) tab.click();
        if (shown()) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        attempts += 1;
        if (attempts < 20) window.setTimeout(reveal, 250);
      };
      form.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      var note = form.querySelector('.xt-rv-note');
      if (note) note.textContent = 'Your review will be marked as a verified purchase and appears after approval.';
      reveal();
    }

    openBtn.addEventListener('click', function () {
      var open = form.hidden;
      form.hidden = !open;
      openBtn.setAttribute('aria-expanded', String(open));
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      var files = Array.prototype.slice.call(form.elements.photos.files || []);
      if (!rating) return showError('Please choose a star rating.');
      if (files.length > MAX_PHOTOS) return showError('You can add up to ' + MAX_PHOTOS + ' photos.');
      submit.disabled = true;
      submit.textContent = 'Sending...';

      Promise.all(files.map(resizePhoto))
        .then(function (photos) {
          return fetch(form.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              productId: form.dataset.productId,
              rating: rating,
              title: form.elements.title.value,
              text: form.elements.text.value,
              author: form.elements.author.value,
              website: form.elements.website.value,
              token: purchaseToken || undefined,
              photos: photos
            })
          });
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) { return { res: res, body: body }; });
        })
        .then(function (r) {
          if (r.res.ok) {
            form.hidden = true;
            openBtn.hidden = true;
            thanks.hidden = false;
            return;
          }
          var msg = r.body.errors ? Object.keys(r.body.errors).map(function (k) { return r.body.errors[k]; }).join(' ') : r.body.error;
          throw new Error(msg || 'Something went wrong. Please try again.');
        })
        .catch(function (err) {
          showError(err.message || 'Something went wrong. Please try again.');
          submit.disabled = false;
          submit.textContent = 'Submit review';
        });
    });
  }

  function initLightbox(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.xt-rv-photo');
      if (!btn) return;
      var overlay = document.createElement('div');
      overlay.className = 'xt-rv-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-label', 'Customer photo');
      var img = document.createElement('img');
      img.src = btn.dataset.full;
      img.alt = 'Customer photo';
      overlay.appendChild(img);
      function close() { overlay.remove(); document.removeEventListener('keydown', onKey); btn.focus(); }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      overlay.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
      document.body.appendChild(overlay);
    });
  }

  function init() {
    document.querySelectorAll('.xt-rv').forEach(function (root) { initForm(root); initLightbox(root); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
